/* upick-waiver.js — enforce waiver in cart page + drawer (Dawn)
   Prevents checkout until checked and stops change events from bubbling
   into Dawn's quantity handlers. */
(function () {
  function qsa(sel, root) { return (root || document).querySelectorAll(sel); }
  function buttons() {
    return qsa('button[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
  }
  function getBox() { return document.getElementById('upick-waiver-checkbox'); }
  function getMsg() { return document.getElementById('upick-waiver-msg'); }

  function enforce() {
    var box = getBox();
    var need = !!box;                 // only enforce if waiver is present
    var ok = !need || !!box.checked;
    var msg = getMsg();

    buttons().forEach(function (btn) {
      btn.disabled = !ok;
      if (!ok) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    });
    if (msg) msg.style.display = ok ? 'none' : '';
  }

  function bind() {
    var box = getBox();
    if (box && !box._upickBound) {
      // Stop Dawn's cart listeners from treating this as a quantity change
      var stop = function (e) { e.stopPropagation(); enforce(); };
      box.addEventListener('change', stop, true);
      box.addEventListener('input', stop, true);
      box._upickBound = true;
    }
    enforce();
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', bind);

  // Re-bind after cart updates / drawer re-render
  document.addEventListener('cart:updated', bind);
  document.addEventListener('cart:change', bind);
  document.documentElement.addEventListener('cart:refresh', bind);
  new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });

  // Hard guard: block checkout if waiver not accepted
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
    var box = getBox();
    if (t && box && !box.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      enforce();
    }
  }, true);
})();
